import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Grid } from '@mantine/core'
import { Form, useForm } from 'react-hook-form'
import { TextInput, DateInput } from 'react-hook-form-mantine'
import yup from '../lib/yup'
import haxios from '../lib/haxios'
import moment from 'moment'
import { errorToast, successToast } from '../lib/helpers'

const validation = yup.object().shape({
  startDate: yup.date().required('Start date is required').min(new Date(), 'Start date cannot be in the past'),
  endDate: yup.date().required('End date is required').min(yup.ref('startDate'), 'End date must be after start date'),
  reason: yup
    .string()
    .required('Reason is required')
    .min(3, 'Reason must be at least 3 characters')
    .max(500, 'Reason must be less than 500 characters')
})

const HolidayRequestModal = ({ context, id, innerProps }) => {
  const { control } = useForm({
    resolver: yupResolver(validation),
    defaultValues: innerProps.defaultValues || {
      startDate: null,
      endDate: null,
      reason: ''
    }
  })

  const handleSubmit = async (data) => {
    try {
      const formattedData = {
        staffId: innerProps.staffId,
        dtStart: moment(data.startDate).format('YYYY-MM-DD'),
        dtEnd: moment(data.endDate).format('YYYY-MM-DD'),
        reason: data.reason,
        requestDate: moment().format('YYYY-MM-DD'),
        decision: 'PENDING',
        Notes: ''
      }

      if (innerProps.editing) {
        await haxios.put(`/salesassist/cplusassist/holidayrequests/${innerProps.reqId}`, formattedData)
      } else {
        await haxios.post('/salesassist/cplusassist/holidayrequests', formattedData)
      }

      await innerProps.refetch()
      context.closeModal(id)
      successToast('Holiday request submitted.')
    } catch (e) {
      errorToast('An error has occurred.')
      console.log(e)
    }
  }

  return (
    <Form control={control} onSubmit={(e) => handleSubmit(e.data)} onError={(e) => console.log(e)}>
      <Grid gutter="xs">
        <Grid.Col span={6}>
          <DateInput label="Start Date" name="startDate" control={control} />
        </Grid.Col>
        <Grid.Col span={6}>
          <DateInput label="End Date" name="endDate" control={control} />
        </Grid.Col>

        <Grid.Col span={12}>
          <TextInput label="Reason" name="reason" control={control} multiline rows={4} />
        </Grid.Col>

        <Grid.Col span={12}>
          <Button type="submit">Submit</Button>
        </Grid.Col>
      </Grid>
    </Form>
  )
}

export default HolidayRequestModal
